import { compose, getter } from 'utils/functional';

import { Select } from './Select';

type Props = {
  className?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterOption?: (arg0: Record<string, any>, arg1: string) => boolean;
  id?: string;
  name?: string;
  label?: string;
  value: string | null | undefined;
  options: Array<{
    value: string;
    label: string;
  }>;
  disabled?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (...args: Array<any>) => any;
  'data-qa-id'?: string;
  isClearable?: boolean;
  placeholder?: string;
};

export function SearchableSelect({ filterOption, onChange, ...props }: Props) {
  return (
    <Select
      // @ts-expect-error TS(2345): Argument of type '((...args: any[]) => any) | unde... Remove this comment to see the full error message
      onChange={compose(onChange, getter('value'))}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      isSearchable
    />
  );
}
